const ArrowNext = () => (
    <svg width="12" height="20" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.25 1L5.75 5.5L1.25 10" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default ArrowNext